import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { useIntl } from 'react-intl';
import Button from '../../../../../atoms/buttons/Button';
import css from './MerchantCourseDetailsReservationButton.module.scss';

import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';

interface OwnProps {
  nickname: string;
  public_id: string;
  isBookable: boolean;
  contactUrl: string | null;
}

type CarryOverQueryWhenEnterReservationFlowKey =
  | 'selected_date'
  | 'selected_slot'
  | 'selected_lesson'
  | 'selected_course'
  | 'selected_staff';
type CarryOverQueryWhenEnterReservationFlow = {
  [key in CarryOverQueryWhenEnterReservationFlowKey]?: string;
};

type Props = OwnProps;

const MerchantCourseDetailsReservationButton: React.FC<Props> = ({
  isBookable,

  nickname,
  public_id,
  contactUrl,
}) => {
  const intl = useIntl();
  const classes = classNames(css.MerchantCourseDetailsReservationButton);

  const router = useRouter();

  const carryOverQuery = extractCarryOverQueryFromCurrentUrl(router.query);

  const bookingFlowEnterPath = `/${nickname}/${public_id}/book`;

  const contactPageHref = contactUrl || `/${nickname}/contact?via=${public_id}`;

  return (
    <span className={classes}>
      {isBookable ? (
        <Link
          href={{ pathname: bookingFlowEnterPath, query: carryOverQuery }}
          prefetch={false}
          passHref={true}
          legacyBehavior
        >
          <Button
            className_Deprecated={
              css.MerchantCourseDetailsReservationButton__Button
            }
          >
            {intl.formatMessage({
              id: 'merchants.bookingPages.reservation',
            })}
          </Button>
        </Link>
      ) : (
        <a href={contactPageHref}>
          <Button
            href={contactPageHref}
            className_Deprecated={
              css.MerchantCourseDetailsReservationButton__Button
            }
          >
            {intl.formatMessage({
              id: 'merchants.bookingPages.inquiry',
            })}
          </Button>
        </a>
      )}
    </span>
  );
};

const extractCarryOverQueryFromCurrentUrl = (
  query: ParsedUrlQuery,
): CarryOverQueryWhenEnterReservationFlow => {
  const extracted: CarryOverQueryWhenEnterReservationFlow = {};

  const extract = (key: keyof CarryOverQueryWhenEnterReservationFlow) => {
    const q = query[key];

    if (typeof q === 'string') {
      extracted[key] = q;
    }
  };

  extract('selected_staff');
  extract('selected_course');
  extract('selected_lesson');
  extract('selected_slot');
  extract('selected_date');

  return extracted;
};

export default MerchantCourseDetailsReservationButton;
